import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const BathIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className={className} onClick={onClick}>
      <path fill="currentColor" d="M18 11V2.83C18 1.27 16.73 0 15.17 0C14.42 0 13.7 0.3 13.17 0.83L11.92 2.08C11.76 2.03 11.59 2 11.41 2C11.01 2 10.64 2.12 10.33 2.32L13.09 5.08C13.29 4.77 13.41 4.4 13.41 4C13.41 3.82 13.38 3.66 13.34 3.49L14.59 2.24C14.74 2.09 14.95 2 15.17 2C15.63 2 16 2.37 16 2.83V11H9.15C8.85 10.79 8.58 10.55 8.33 10.28L6.93 8.73C6.74 8.52 6.5 8.35 6.24 8.23C5.93 8.08 5.59 8 5.24 8C4 8.01 3 9.01 3 10.25V11H0V17C0 18.1 0.9 19 2 19C2 19.55 2.45 20 3 20H17C17.55 20 18 19.55 18 19C19.1 19 20 18.1 20 17V11H18ZM18 17H2V13H18V17Z"/>
    </svg>
  );
};

export default BathIcon;
